var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2467 0C24.2798 0 0 24.2798 0 54.2467C0 84.2136 24.2798 108.493 54.2467 108.493C84.2136 108.493 108.493 84.2136 108.493 54.2467C108.493 24.2798 84.2136 0 54.2467 0ZM79.5545 59.4963L41.0569 81.5887C37.6008 83.5136 33.248 81.0419 33.248 76.9953V31.4981C33.248 27.4733 37.5789 24.9797 41.0569 26.9046L79.5545 50.3094C83.1418 52.3218 83.1418 57.5058 79.5545 59.4963Z",
    fill: "url(#paint0_linear_252_19)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_252_19",
    x1: -4.03169e-8,
    y1: 88.5,
    x2: 54.2467,
    y2: 108.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0272634,
    stopColor: "#6A3F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938491,
    stopColor: "#F4BEA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay4);
export default __webpack_public_path__ + "static/media/play4.8aa7449536e2aa776f1d4fbc9da88f7a.svg";
export { ForwardRef as ReactComponent };